export const CHECKOUT_PLAN = 'app:CHECKOUT_PLAN';
export function checkoutPlan(planId, failCb) {
  return {
    type: CHECKOUT_PLAN,
    planId,
    failCb
  };
}
